import colors from '../../../styles/colors';
import styled from 'styled-components';

export const PostCallWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Logo = styled.div`
  width: 100%;
  min-height: 85px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    background: ${colors.blue['500']};
    border-radius: 4px;
    overflow: hidden;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  box-shadow: 0 4px 4px 0 rgba(0, 19, 67, 0.08);
  max-width: 580px;
  border: 1px solid rgba(230, 229, 236, 1);
  border-radius: 16px;
  overflow: hidden;
  margin: 40px 20px;
`;

export const Title = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 24px;
  background: ${colors.grey['100']};
  height: 150px;
  overflow: hidden;

  span {
    display: flex;
    font-size: 32px;
    font-weight: 600;
    color: ${colors.blue['950']};
    max-width: 250px;
    word-break: break-word;
  }

  svg {
    bottom: -30px;
    right: -45px;
    position: absolute;
    height: 200px;
    width: 300px;
  }

  @media (max-width: 640px) {
    span {
      font-size: 24px;
      max-width: 180px;
    }

    svg {
      height: 166px;
      width: 250px;
      bottom: -35px;
      right: -45px;
    }
  }

  @media (max-width: 480px) {
    span {
      font-size: 20px;
      max-width: 120px;
    }

    svg {
      height: 133px;
      width: 200px;
      bottom: -35px;
      right: -45px;
    }
  }
`;

export const Description = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 24px;
  color: ${colors.grey['700']};
  font-size: 14px;
  line-height: 24px;

  strong {
    color: ${colors.blue['950']};
  }

  ul {
    margin: 0;
    padding: 0 0 0 24px;
  }
`;

export const Center = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  max-width: 1240px;
  justify-content: center;
  align-items: center;
  margin-bottom: 125px;
  padding: 0 24px;
`;

export const PoweredBy = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  height: 33px;
  box-shadow: 0 4px 20px 0 rgba(0, 34, 122, 0.12);
  font-size: 12px;
  background: #ffffff;
  border-top: 1px solid #e6e5ec;
  width: 100%;
    
  a {
    color: ${colors.blue['950']};
    text-decoration: none;
  }
`;
